import { setLogLevel } from '@ms/yammer-console-logging';
import type { I18nState } from '@ms/yammer-i18n-react';
import { i18nReducer, setLocaleFromBrowser } from '@ms/yammer-i18n-react';
import type { AnyAction, Reducer, Store } from 'redux';

import { publicPagesRootPath } from '../../../routes';
import type { StaticPagesState } from '../../../state/types';
import config from '../../config';
import { loadFailureRenderer, loadMainRenderer } from '../3-render';

import { createEnhancedStore } from './createEnhancedStore';

export const bootstrapApp = async (): Promise<void> => {
  let store: Store<StaticPagesState> | undefined;

  try {
    setLogLevel(config.logging.logLevel);

    const enhancedStore = createEnhancedStore<StaticPagesState>({
      reducers: { i18n: i18nReducer as Reducer<I18nState, AnyAction> },
    });

    store = enhancedStore.store;

    setLocaleFromBrowser(store.dispatch, store.getState());

    const render = await loadMainRenderer();

    render({ basename: publicPagesRootPath, target: document.getElementById('root') as HTMLElement, store });
  } catch (error) {
    console.error(error);

    if (store) {
      setLocaleFromBrowser(store.dispatch, store.getState());
    }

    const renderFailure = await loadFailureRenderer();
    renderFailure({ target: document.getElementById('root') as HTMLElement, store });
  }
};
